<template>
  <van-popup v-model="showPrize" round>
    <div class="prizeWrap">
      <img :src="prize.picUrl"/>
      <span>{{prize.prizeName}}</span>
      <span class="tip">{{ $i18n('congratulationsWon', '恭喜您中奖了！') }}</span>
    </div>
  </van-popup>
</template>

<script>
import {mapGetters} from "vuex";
import {_code} from "@utils/constant";
import i18nMixin from "@libs/i18nMixin";
export default {
  name: "WinnerNotice",
  data() {
    return {
      showPrize:false,
      prize:{}
    };
  },
  mixins: [i18nMixin],
  computed:{
    ...mapGetters(["live", "lottery"])
  },
  methods:{
    handleSocketMessage(msg) {
      switch (msg.msgType) {
        case _code.WINNER_NOTICE:
          const jsonData = JSON.parse(msg.data);
          this.showPrize = true;
          this.prize = jsonData;
          setTimeout(()=>{
            this.showPrize = false;
          },5000)
        break;
      }
    }
  },
  mounted() {
    this.handleSocketMessage = this.handleSocketMessage.bind(this);
    this.$store.commit('ADD_MESSAGE_LISTENER', this.handleSocketMessage);
    this.$Bus.$on("noticeWinner", msg => {
      console.log('消息-----',msg)
      const jsonData = JSON.parse(msg);
      this.showPrize = true;
      this.prize = jsonData;
      setTimeout(()=>{
        this.showPrize = false;
      },5000)
    });
  },
  beforeDestroy() {
    this.$store.commit('REMOVE_MESSAGE_LISTENER', this.handleSocketMessage);
    this.$Bus.$off("noticeWinner");
  }
};
</script>

<style lang="less" scoped>
.prizeWrap{
  width: 300px;
  height: 320px;
  //padding: 20px 0;
  background-image: url("~@images/live/bg_get_win.gif");
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  box-sizing: border-box;
  img{
    width: 130px;
  }
  span{
    margin-top: 10px;
    font-size: 28px;
    font-weight: 300;
    color: #FFF;
  }
  .tip{
    color: red;
    text-shadow: 0 -2px #fff, 2px 0px #fff, 0 2px #fff, -2px 0 #fff,
      -2px -2px #fff, 2px 2px #fff, 2px -2px #fff, -2px 2px #fff;
  }
}
</style>
